import React, {  useState , useEffect} from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import UpdateInfomationsSignataire from '../UpdateInfomationsSignataire/UpdateInfomationsSignataire'
import CommandeFilesModal from '../Files/CommandeFilesModal'
import { useTranslation } from 'react-i18next'
function MiseADispoHorizontal({
	commande,
	onClickDetails = () => {},
	onClickFacture=()=>{},
	onClickAvoir=()=>{},
	onClickMissions=()=>{},
	hideTransfert=true,
	hidecancel=false,
	hideTarif = false,
	hidefacture=false,
	hideFile=false,
	hideUpdate=false,
	hideSignalement=false,
	hideMission=false,
	hideAddFile=false,
	hideRemoveFile=false,
	onClickCancel=()=>{},
	onClickPayer=()=>{},
	onClickSignaler=()=>{},

}) {
	const user = useSelector(state => state.auth.user)
	const [modalIsOpenUpdate,setModalIsOpenUpdate]=useState(false)
    const [modalIsOpenFiles,setModalIsOpenFiles]=useState(false)
	
	
	const findClosestMission = (missions) => {
		const validMissions = missions
			.filter(mission => mission.statut !== "annuler") 
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_debut} ${a.heure_debut}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_debut} ${b.heure_debut}`, "DD/MM/YYYY HH:mm");
				return aDateTime - bDateTime;
			});
	
		if (validMissions.length === 0){
			const sortedAnnulerMissions=missions
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_debut} ${a.heure_debut}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_debut} ${b.heure_debut}`, "DD/MM/YYYY HH:mm");
				return aDateTime - bDateTime;
			});
			return sortedAnnulerMissions[0]
		}
	
		return validMissions[0];
	};
	
	const closestMission = findClosestMission(commande?.missions);
	
    // Calculate additional costs (difference between prix_total and initial price )
    const additionalCosts = (commande?.prix_total || 0) - (commande?.prix || 0);

	const findLatestMission = (missions) => {
		const validMissions = missions
			.filter(mission => mission.statut !== "annuler") 
			.sort((a, b) => { 
				const aDateTime = moment(`${a.date_fin} ${a.heure_fin}`, "DD/MM/YYYY HH:mm");
				const bDateTime = moment(`${b.date_fin} ${b.heure_fin}`, "DD/MM/YYYY HH:mm");
				return bDateTime - aDateTime;
			});
			
			
		if (validMissions.length === 0){
				const sortedAnnulerMissions=missions
				.sort((a, b) => { 
					const aDateTime = moment(`${a.date_fin} ${a.heure_fin}`, "DD/MM/YYYY HH:mm");
					const bDateTime = moment(`${b.date_fin} ${b.heure_fin}`, "DD/MM/YYYY HH:mm");
					return bDateTime - aDateTime;
				});
				return sortedAnnulerMissions[0]
			}
		return validMissions[0];
	};
	const latestMission = findLatestMission(commande?.missions);
	
	const totalForfaitsSupp = commande.missions
    .filter(mission => mission.statut !== 'annuler')
    .reduce((total, mission) => {
        const totalForfaitsMission = mission.forfaits
            ?.reduce((totalForfait, forfait) => totalForfait + (forfait.prix || 0), 0) || 0;
        
        return total + totalForfaitsMission;
    }, 0);

	const{t} = useTranslation()
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
	const [isTablette, setIsTablette] = useState(() => window.innerWidth <= 1024 && window.innerWidth > 768);

	useEffect(() => {
		const checkScreen = () => {
			const width = window.innerWidth;

			setIsMobile(width <= 768);
			setIsTablette(width > 768 && width <= 1024);
		};
		checkScreen();
		window.addEventListener('resize', checkScreen);

		return () => window.removeEventListener('resize', checkScreen);
	}, []);
	return (
		<div
			style={{
				width: '100%',
				background: '#E4EAF0',
				display: 'flex',
				flexDirection: isMobile ? 'column' : 'row',
				padding: '1rem',
				borderRadius: 10,
				alignItems: 'flex-start',
				justifyContent: 'space-between',
				marginBottom: 10,
				gap : 10
			}}
		>
			<div style={{
					display: 'flex',
					flexDirection: isMobile || isTablette ? 'column' : 'row',
					gap: '10px'
				}}>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						color: '#51C7F2',
						marginBottom: "1rem",
					}}
				>
					{t("mise_à_disposition")} {!!commande ? 'N°' + commande.__id : '' } /{' '}
					<span style={{ color: '#1C63C5' }}>
						{commande.temporisation === 'immediat'
							? t("immédiate")
							: t("planifiée")}
					</span>
				</span>
                <div 
				style={{
					display: 'flex',
					flexDirection: 'row'
				}}>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("transport_date")} :{' '}
					<span
						style={{
							marginRight: 13,
							color: '#838EAB',
							fontWeight: 'bolder'

						}}
					>

                    {moment(commande.date_transport).format('DD/MM/YYYY')}
                 </span>
				</span>
				
				</div>
				
                <span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginBottom: '1rem',

					}}
				>
					{t("creation_date")} :{' '}
					<span
						style={{
							marginRight: 13,
							color: '#838EAB',
							fontWeight: 'bolder'
						}}
					>
				    {moment(commande.createdAt).format('DD/MM/YYYY')}
					</span>
				</span>
				<span
					style={{
						marginRight: 13,
						marginBottom: '1rem',
						color: '#838EAB',
						width: '15rem',

					}}
				>
          {t("start_date")}:  {' '}
		  <span 
		  style={{color: '#838EAB', fontWeight: 'bolder'
           }}>
		   {closestMission?.date_debut}{' '}
           {closestMission?.heure_debut}{' '}
           {closestMission?.adresse_debut?.label}
		  </span>
		 
				</span>


        <span
        style={{
        marginRight: 13,
        color: '#838EAB',
        width: '15rem',
         }}
        >
        {t("end_date")}:{' '}
      <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
	  {latestMission?.date_fin}{' '}
      {latestMission?.heure_fin}{' '}
      {latestMission?.adresse_fin?.label}
      </span>
      </span>

                <span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,

					}}
				>
					 {t("payment_status")} :{' '}
					<span
						style={{
							marginRight: 13,
							color: '#838EAB',
							fontWeight: 'bolder'
						}}
					>
				 {commande.paymentStatus==='payé' ? t("paid") : t("unpaid")}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,

					}}
				>
					 {t("order_status")} :{' '}
					<span
						style={{
							marginRight: 13,
							color: '#838EAB',
							fontWeight: 'bolder'
						}}
					>
                    {commande?.statut==="init" && t("not_started")}
                    {commande?.statut==="en-cours" && t("in_progress")}
                    {commande?.statut==="terminer" && t("completed")}
                   {commande?.statut==="annuler" && t("cancelled")}
					</span>
				</span>
				{(!hideTransfert && commande.recu && commande.statut==="en-cours") && (
				<span
					style={{
						color: '#838EAB',
						width: '15rem',
						marginTop: 10,
						
					}}
				>
					 {t("transfer_status")} :{' '}
					<span
						style={{
							marginRight: 15,
							color: '#838EAB',
							fontWeight: 'bolder'
						}}
					>
             {commande?.statutTransfert === 'transferé' && t("transferred")}
             {commande?.statutTransfert==="en cours de transfert" && t("in_transfer")}
             {commande?.statutTransfert==="aucun transfert" && t("no_transfers" )}

					</span>
				</span>
				)}
				<span
					style={{
						color: '#838EAB',
						marginTop: 10,

					}}
				>
					{t("number_of_missions")}: {' '}
					<span style={{color: '#838EAB', fontWeight: 'bolder'}}>
					{commande?.missions?.length}
					</span>
					
				</span>
			</div>

			{/*  */}
             
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					height: '100%',

				}}
			>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("number_of_loaders")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
					{commande.statut!=="annuler" ?(commande?.missions
                    ?.filter(mission => mission.statut !== "annuler")
                    ?.reduce((total, mission) => total + (mission?.nombre_rippeur || 0), 0) || 0)
				    :
					(commande?.missions
						?.reduce((total, mission) => total + (mission?.nombre_rippeur || 0), 0) || 0)
				    }  

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					Documents :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
					{commande.statut!=="annuler"  ? (commande?.files?.length || 0 + 
					commande?.missions
					?.filter(mission=>mission.statut!=="annuler")
					?.reduce((total, mission) => total + (mission.files?.length || 0), 0))
					:
					(commande?.files?.length || 0 + 
						commande?.missions
						?.reduce((total, mission) => total + (mission.files?.length || 0), 0))
					}

					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("internal_refrence")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
					{commande.ref_client}
					</span>
				</span>
                <span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("total_km")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
					{commande.statut!=="annuler" ?(commande?.missions
                    ?.filter(mission => mission.statut !== "annuler")
                    ?.reduce((total, mission) => total + (mission?.kilometrage || 0), 0) || 0)
				    :
				    (commande.distance)
				    }  
					</span>
				</span>
				{user?.role==="client" && 
				<span
				style={{
					color: '#838EAB',
					marginBottom: '1rem',

				}}
			>
				 {t("assignment")} :{' '}
				 <span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
				{!commande.transporterID && t("unassigned")}
				 {(commande.transporterID && !commande.chauffeurID ) && t("assigned_transporter") }
				</span>
			 </span>
			 
                }
				<span
						style={{
							color: '#838EAB',
							marginBottom: '.5rem',

						}}
					>
						{t("useful_note")}:{' '}
						<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.statut!=="annuler"? 
						 (commande?.missions
                         ?.filter(mission => mission.statut !== "annuler")
                         ?.some(mission => mission?.notes?.length > 0) ? t("yes") : t("no"))
						  :
						  (commande?.missions
							?.some(mission => mission?.notes?.length > 0) ? t("yes") : t("no"))
						 }						
						 
						 </span>
				</span>
				{commande?.statut==="annuler" &&
				<>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("refund_status")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
					{commande.statut_remboursement}
					</span>
				</span>
				<span
					style={{
						color: '#838EAB',
						marginBottom: '1rem',

					}}
				>
					{t("cancellation_date")} :{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
					{moment(commande?.date_annulation)?.format("DD/MM/YYYY")}
					</span>
				</span>
				</>
                }
				
			</div>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				{!hideTarif && (
				 <>
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .1rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
							{t("total_amount")}:{' '}
							

							{
						    (commande?.prix_total ?? (commande.prix + totalForfaitsSupp)).toFixed(2) 

                            }€
						</span>
					</span>
				</div> 
				
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .2rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
						marginTop:2
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
						{t("initial_amount")}:{' '}
							
							{
                              commande.prix.toFixed(2)
                            }€
						</span>
					</span>
				</div> 
				{!commande?.prix_total && (
				 <div
					style={{
						background: 'white',
						padding: '0.2rem .2rem',
						display: 'flex',
						flexDirection: 'row',
						color: '#838EAB',
						fontSize: 13,
						borderRadius: 5,
						marginBottom: 3,
					}}
				>
					<span
						style={{
							marginRight: 15,
							display: 'flex',
							flexDirection: 'column',
							fontWeight: 'bold',
							fontSize: 14,
							padding: '1rem 0.3rem',
						}}
					>
						<span>
						{t("package_amount")}:{' '}
							{
                             totalForfaitsSupp?.toFixed(2)
                            }€
						</span>
					</span>
				</div>)}
				{additionalCosts > 0 && (
                            <div style={{
                                background: 'white',
                                padding: '0.2rem .2rem',
                                display: 'flex',
                                flexDirection: 'row',
                                color: '#838EAB',
                                fontSize: 13,
                                borderRadius: 5,
                                marginBottom: 3,
                            }}>
                                <span style={{
                                    marginRight: 15,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    fontWeight: 'bold',
                                    fontSize: 14,
                                    padding: '1rem 0.3rem',
                                }}>
                                    <span>
                                        {t("additional_amount")}: {additionalCosts.toFixed(2)}€
                                    </span>
                                </span>
                            </div>
                        )}
				</> 
			    )}
				{hideTarif && 
				 <div
				 style={{
					 background: 'white',
					 padding: '0.2rem .2rem',
					 display: 'flex',
					 flexDirection: 'row',
					 color: '#838EAB',
					 fontSize: 13,
					 borderRadius: 5,
					 marginBottom: 3,
					 marginTop:2
				 }}
			 >
				 <span
					 style={{
						 marginRight: 15,
						 display: 'flex',
						 flexDirection: 'column',
						 fontWeight: 'bold',
						 fontSize: 14,
						 padding: '1rem 0.3rem',
					 }}
				 >
					 <span>
					     {t("amount")}:  {' '}
						 {
						   commande?.prix.toFixed(2)
						 }€
					 </span>
				 </span>
			     </div>
				}
				{hideTarif &&
				 <div
				 style={{
					 background: 'white',
					 padding: '0.2rem .2rem',
					 display: 'flex',
					 flexDirection: 'row',
					 color: '#838EAB',
					 fontSize: 13,
					 borderRadius: 5,
					 marginBottom: 3,
					 marginTop:2
				 }}
			 >
				 <span
					 style={{
						 marginRight: 15,
						 display: 'flex',
						 flexDirection: 'column',
						 fontWeight: 'bold',
						 fontSize: 14,
						 padding: '1rem 0.3rem',
					 }}
				 >
					 <span>
					     {t("refunded_amount")}: {' '}
						 {
						   commande?.prixRembourse.toFixed(2)
						 }€
					 </span>
				 </span>
			     </div>
				}
			    
				
                
			</div>

			{/*  */}

			<div
				style={{
					color: '#838EAB',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
				}}
			>
				<span>
					{t("handling_eq1")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes('Diable') && t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq2")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
						{commande.manutention.includes('Transpalette manuel') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq3")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes(
							'Transpalette électrique'
						) && t("yes")}
					</span>
				</span>
				<span>
					{t("handling_eq4")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.manutention.includes('Sangle') && t("yes")}
					</span>
				</span>

				<span>
					{t("ppe_eq1")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
						{commande.epi.includes('Casque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq2")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Gants') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq3")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Masque') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq4")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder' }}>
						{commande.epi.includes('Lunettes') && t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq5")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
						{commande.epi.includes('Chaussure de sécurité') &&
							t("yes")}
					</span>
				</span>
				<span>
					{t("ppe_eq6")}:{' '}
					<span style={{ color: '#838EAB', fontWeight: 'bolder'}}>
						{commande.epi.includes('Gilet de visibilité') && t("yes")}
					</span>
				</span>
			</div>
            </div>
			<div
				style={{
					//width: '16%',
					display: 'flex',
					flexDirection: 'column',
					fontSize: 13,
					marginTop: 35,
				}}
			>
				
				<button
					onClick={onClickDetails}
					style={{
						padding: '0.5rem 1.5rem',
						background: '#51C7F2',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("view_details")}
				</button>
				{!hideSignalement &&
				<button
				onClick={onClickSignaler}
				style={{
					padding: '0.5rem 1.5rem',
					background: '#838EAB',
					border: 'none',
					cursor: 'pointer',
					color: 'white',
					borderRadius: 7,
					marginTop: 5,
					fontFamily: 'Montserrat',
					fontWeight: 'bold',
				}}
			>
				{t("reports")}
			   </button>
                }
				
				{!hidefacture &&
				<button
					onClick={onClickFacture}
					style={{
						padding: '0.5rem 1.5rem',
						background: '#99ff99',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("view_invoice")}
				</button>
                }
				{!hidefacture &&  commande.statut==="annuler" && commande.statut_remboursement==="remboursé" &&
				<button
					onClick={onClickAvoir}
					style={{
						padding: '0.5rem 1.5rem',
						background: '#99ff99',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("view_credit_note")}
				</button>
                }
				{!hidecancel&&
				<button
					onClick={onClickCancel}
					style={{
						padding: '0.5rem 1.5rem',
						background:commande?.statut ==="annuler" ? 'red' : '#ff9999',
						border: 'none',
						cursor: 'pointer',
						borderRadius: 7,
						color: commande?.statut ==="annuler"? 'white' : 'white',
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("cancel")}
				</button>
                }
				{(!hidecancel && !user.premium && commande.prix!==0 &&  commande.paymentStatus==="non payé")&&
				<button
					onClick={onClickPayer}
					style={{
						padding: '0.5rem 1.5rem',
						background:commande?.statut ==="payé" ? '#66ff66' : '#99ff99',
						border: 'none',
						cursor: 'pointer',
						color: 'white',
						borderRadius: 7,
						marginTop: 5,
						fontFamily: 'Montserrat',
						fontWeight: 'bold',
					}}
				>
					{t("pay")}
				</button>
                }
				{!hideUpdate && 
				<button
				onClick={()=>setModalIsOpenUpdate(true)}
				style={{
					padding: '0.5rem 1.5rem',
					background:'#5bc0de',
					border: 'none',
					cursor: 'pointer',
					color: 'white',
					borderRadius: 7,
					marginTop: 5,
					fontFamily: 'Montserrat',
					fontWeight: 'bold',
				}}
			>
				{t("edit")} {t("signatory")}
			   </button>
				}
			
			    <>
				{!hideMission &&
				<button 
				onClick={onClickMissions}
				style={{
					padding: '0.5rem 1.5rem',
					background:'#5bc0de',
					border: 'none',
					cursor: 'pointer',
					color: 'white',
					borderRadius: 7,
					marginTop: 5,
					fontFamily: 'Montserrat',
					fontWeight: 'bold',
				}}>
					{t("mission_management")}
				</button>
                }
				</>
				{!hideFile &&
			    <button 
				onClick={()=>setModalIsOpenFiles(true)}
				style={{
					padding: '0.5rem 1.5rem',
					background:'#5bc0de',
					border: 'none',
					cursor: 'pointer',
					color: 'white',
					borderRadius: 7,
					marginTop: 5,
					fontFamily: 'Montserrat',
					fontWeight: 'bold',
				}}>
					{t("manage_documents")}
				</button>
                }
			</div>
			
		
		     <UpdateInfomationsSignataire
			 commandeId={commande._id}
			 modalIsOpenUpdate={modalIsOpenUpdate}
			 setModalIsOpenUpdate={setModalIsOpenUpdate}
			 />
	         <CommandeFilesModal
		       isOpen={modalIsOpenFiles}
		       onClose={()=>setModalIsOpenFiles(false)}
		       commandeId={commande?._id}
			   hideAddFile={hideAddFile}
			   hideRemoveFile={hideRemoveFile}
		    />
			
		
			
		</div>
	)
}

export default React.memo(MiseADispoHorizontal)
